import React, { createContext, useContext, useReducer } from "react";
import ReservationsReducer from "../reducers/ReservationsReducer";
import ReservationsService from "../services/ReservationsService";
import {
  ENABLE_RESERVATIONS,
  DISABLE_RESERVATIONS,
  RESERVATIONS_RECIBIDAS,
  SET_RESERVATION,
  SET_UPDATED,
} from "../types";
import { hideModal } from "../utils";
import { ModalContext } from "./ModalContext";
import { AuthContext } from "./AuthContext";

const initialState = {
  reservations: null,
  reservation: null,
  updated: false,
  disabled: false,
};

export const ReservationsContext = createContext(initialState);

export const ReservationsProvider = ({ children }) => {
  const [state, dispatch] = useReducer(ReservationsReducer, initialState);

  const { success, alert } = useContext(ModalContext);

  const { getUsuario } = useContext(AuthContext);

  const enableReservations = () => {
    dispatch({ type: ENABLE_RESERVATIONS });
  };

  const getMyReservations = () => {
    ReservationsService.getMyReservations().then((res) => {
      const { class_reservations } = res.data;
      dispatch({ type: RESERVATIONS_RECIBIDAS, payload: class_reservations });
    });
  };

  const setReservation = (reservation) => {
    dispatch({ type: SET_RESERVATION, payload: reservation });
  };

  const cancelReservacion = (class_reservation_id, callback) => {
    ReservationsService.cancelReservation(class_reservation_id)
      .then(() => {
        hideModal();
        success("¡Reservación cancelada con éxito!");
        getMyReservations();
        if (typeof callback === "function") {
          callback();
        }
        getUsuario();
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.status === 412) {
            hideModal();
            alert(
              "Lo sentimos, para cancelar tu clase necesitas al menos 12 horas de anticipación."
            );
          }
        }
        if (typeof callback === "function") {
          callback();
        }
      });
  };

  const postReservacion = (clase, callback) => {
    let service;
    dispatch({ type: DISABLE_RESERVATIONS });
    if (clase.class_reservation_id) {
      service = ReservationsService.putReservation(clase);
    } else {
      service = ReservationsService.postReservation(clase);
    }
    service
      .then(() => {
        success(
          "¡Reservación guardada con éxito! Recuerda llegar a tiempo a tu clase, tienes 10 min de tolerancia desde que comienza la clase."
        );
        dispatch({ type: SET_UPDATED });
        if (typeof callback === "function") {
          callback();
        }
        getMyReservations();
        getUsuario();
      })
      .catch((error) => {
        enableReservations();
        
        if (error.response) {
          if(error.response?.data?.message?.length > 0) {
            return alert(error.response.data.message);
          }
          
          if (error.response.status === 412) {
            return alert(
              "Lo sentimos, ya no tienes créditos vigentes para clases presenciales."
            );
          } else if (error.response.status === 409) {
            return alert(
              "Ya has reservado esta clase, refresca la página para verlo reflejado."
            );
          }
        }
        if (typeof callback === "function") {
          callback();
        }
      });
  };

  const postAttend = (class_reservation_id, attend) => {
    ReservationsService.postAttend(class_reservation_id, attend).then(() => {
      success(attend ? "Asistencia registrada." : "Asistencia cancelada");
    });
  };

  const updateGuestName = (class_reservation_id, name) => {
    ReservationsService.updateGuestName(class_reservation_id, name).then(() => {
      success("¡Nombre actualizado!");
    });
  };

  const eliminarReservacion = (class_reservation_id) => {
    ReservationsService.deleteAsistente(class_reservation_id).then(() => {
      success("¡Reservacion eliminada!");
      hideModal();
    });
  };

  const updateReservacion = (class_reservation) => {
    ReservationsService.putReservacion(class_reservation).then(() => {
      success("Reservación actualizada.");
      getMyReservations();
      hideModal();
    });
  };

  return (
    <ReservationsContext.Provider
      value={{
        ...state,
        postAttend,
        setReservation,
        postReservacion,
        updateGuestName,
        updateReservacion,
        cancelReservacion,
        getMyReservations,
        enableReservations,
        eliminarReservacion,
      }}
    >
      {children}
    </ReservationsContext.Provider>
  );
};
